import { Link } from 'react-router-dom';
import type { Comic } from '@/types/comic';
import ComicCard from '@/components/base/ComicCard';

interface ComicSectionProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  comics: Comic[];
  showAuthor?: boolean;
}

export default function ComicSection({
  title,
  subtitle,
  moreTo,
  moreLabel = '查看全部',
  comics,
  showAuthor = false,
}: ComicSectionProps) {
  return (
    <section className="w-full">
      <div className="flex items-end justify-between mb-5 gap-4">
        <div className="min-w-0">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">{title}</h2>
          {subtitle && <p className="mt-1 text-sm text-foreground-600">{subtitle}</p>}
        </div>
        {moreTo && (
          <Link
            to={moreTo}
            className="shrink-0 inline-flex items-center gap-1 text-sm font-label font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            {moreLabel}
            <i className="ri-arrow-right-line"></i>
          </Link>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {comics.map((comic) => (
          <ComicCard key={comic.id} comic={comic} showAuthor={showAuthor} />
        ))}
      </div>
    </section>
  );
}